import { createLazyComponent, preloadComponents } from '../LazyComponent';

// Re-export for convenience
export { preloadComponents };

// Lazy load grid components
export const LazySftpLogsGrid = createLazyComponent(
  () => import('../SftpLogsGrid').then(m => ({ default: m.SftpLogsGrid })),
  { preload: true }
);

export const LazyIterationsGrid = createLazyComponent(
  () => import('../IterationsGrid').then(m => ({ default: m.IterationsGrid })),
  { preload: true }
);

export const LazySimpleIterationsGrid = createLazyComponent(
  () => import('../SimpleIterationsGrid').then(m => ({ default: m.SimpleIterationsGrid })),
  { preload: true }
);

export const LazyInventoryGrid = createLazyComponent(
  () => import('../InventoryGrid').then(m => ({ default: m.InventoryGrid })),
  { preload: true }
);

// Lazy load heavy dialogs
export const LazySftpTenantConfigDialog = createLazyComponent(
  () => import('../../pages/sftp-sync/SftpTenantConfigDialog').then(m => ({ default: m.SftpTenantConfigDialog })),
  { preload: false }
);

export const LazySftpSqlColumnMapDialog = createLazyComponent(
  () => import('../../pages/sftp-sync/SftpSqlColumnMapDialog').then(m => ({ default: m.SftpSqlColumnMapDialog })),
  { preload: false }
);

// Export all lazy components for preloading
export const criticalComponents = [
  LazySftpLogsGrid,
];

export const nonCriticalComponents = [
  LazyIterationsGrid,
  LazySimpleIterationsGrid,
  LazyInventoryGrid,
  LazySftpTenantConfigDialog,
  LazySftpSqlColumnMapDialog,
];